export { default } from './head';
